export function getView(event_type, type, expanded) {
  return (
    event_type === 'appointment_bookings_state_update' &&
    type === 'send_communication' &&
    expanded
  )
}
